@let showLabel = props.label && !props.hideLabel;

@if (showLabel) {
  <div>
    <label [attr.for]="id">
      {{ props.label }}
      @if (props.required && !props.hideRequiredMarker) {
        <span>*</span>
      }
    </label>
  </div>
}

<div class="file-card-body" [class.invalid-feedback]="hasErrors">
  <label [ngClass]="{'file-over': hasDropZoneOver}" class="well my-drop-zone" [class.big]="isBig">

    @if (isBig) {
      <p>
        <tui-icon icon="upload" [style.font-size.px]="50"/>
      </p>
      <h4 i18n="@@ZagruzitFayly">Загрузить файлы </h4>
      <div class="my-drop-zone-info" i18n="@@NazhmiteChtobyZagruzitIliPeretaschite">Нажмите, чтобы загрузить, или перетащите сюда&nbsp;файл</div>

    } @else {
      <tui-icon icon="upload"/>
      {{ fileName }} @if (props.required && !showLabel && !file) {
        <span>*</span>
      }
    }

    <input (change)="onFileSelect($event)" type="file" [attr.accept]="accept || null" [multiple]="isMultiple" style="display: none"/>
  </label>

  <div class="my-drop-zone-info">
    @if (!hasErrors) {
      @if (fileSize > 0) {
        {{ fileSize | formatSize }}
      } @else {
        @if (props.description) {
          <div>{{ props.description }}</div>
        }
        @if (maxFileSize) {
          <div i18n="@@MaxFileSize">Максимальный размер файла {{ maxFileSize | formatSize }}</div>
        }
      }
    } @else {
      <formly-validation-message [field]="field"/>
    }
  </div>
</div>
